<div class="full-width-image-section house-top">
    <div class="arrow-up">
        <next-topbar></next-topbar>
        <next-menu></next-menu>

        <div class="container white">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <h1>{{ 'INSURANCE.HOUSE.COMPONENTS.INDEX.TITLE' | translate }}</h1>
                </div>
            </div>

            <p class="home-insurance-text">
                NEXT er blevet til easySure, men du kan stadig vælge de samme gode forsikringer, faktisk med lidt bedre dækning. Ingen binding og ingen skjulte gebyrer.
            </p>

            <div class="col-sm-4 col-sm-offset-4">
                <div class="icon-bg center">
                    <div class="icon-wrap">
                        <i class="nf nf-house-icon-v3"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-sm-12 text-center">
            <br />
            <br />
            <a href="https://ssp.easysure.dk/sales-journey/buildingFire?accept-language=da/?kpcid=20000131" class="btn btn-success calculate-btn">Beregn hos easySure</a>
            <br />
            <br />
        </div>
    </div>
</div>

<trustpilot-carousel></trustpilot-carousel>

<div class="gray-bg">
    <div class="container">
        <next-faqarticle [category]="'FAQ_HOUSE'"></next-faqarticle>
    </div>
</div>

<nicetoknow [pagecode]="'INSURANCE_HOUSE_NICETOKNOW'"></nicetoknow>

<next-footer></next-footer>
